import { Box, Container, Typography, Divider } from "@mui/material";
import { useGetPublicSchoolInfoQuery } from "../../../../../app/authApiSlice";
import { useGetWebsiteSettingsQuery } from "../../../../../app/websiteApiSlice";
import WebsiteHeader from "../../WebsiteHeader";
import WebsiteFooter from "../../WebsiteFooter";
import SeoHead from "../../SeoHead";
import BlockRenderer from "../../BlockRenderer";
import "./classic.css";

export default function ClassicPage({ page, settings: settingsProp }) {
  const { data: school } = useGetPublicSchoolInfoQuery();
  const { data: settings } = useGetWebsiteSettingsQuery(undefined, { skip: !!settingsProp });
  const activeSettings = settingsProp || settings;

  return (
    <Box className="website-classic" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", bgcolor: "#fdfaf5" }}>
      <SeoHead title={page.seo_title || page.title} description={page.seo_description} ogImage={page.seo_og_image} schoolName={school?.name} />
      <WebsiteHeader school={school} navItems={activeSettings?.nav_items} variant="classic" />

      <BlockRenderer blocks={page.page_blocks} />

      {page.featured_image && !page.page_blocks?.length && (
        <Box component="img" src={page.featured_image} alt={page.title}
          sx={{ width: "100%", maxHeight: 380, objectFit: "cover", borderBottom: "4px solid #795548" }}
        />
      )}

      {(page.content?.trim() || !page.page_blocks?.length) && (
        <Container maxWidth="md" sx={{ py: 6, flex: 1 }}>
          {!page.page_blocks?.length && (
            <Typography variant="h3" fontWeight={700} sx={{ fontFamily: "Georgia, serif", mb: 2 }}>{page.title}</Typography>
          )}
          {!page.page_blocks?.length && <Divider sx={{ borderColor: "#795548", borderWidth: 2, mb: 4 }} />}
          {page.content?.trim() && (
            <Box className="prose-content" dangerouslySetInnerHTML={{ __html: page.content }} />
          )}
        </Container>
      )}

      <WebsiteFooter settings={activeSettings} school={school} variant="classic" />
    </Box>
  );
}
